import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Href from 'components/ui/Href/Href'

import s from './Link.scss'


const Link = (props) => {
  const {
    className, styleless,
    underlineBrandColor, underlineDashedBrandColor, blackColor, grayColor,
    brandColor, blackToBrandColor, customColor, color, bold,
    ...rest
  } = props

  const composedClassName = cx(s.link, className, {
    [s.commonColor]: !customColor && !brandColor && !blackColor,
    [s.brandColor]: brandColor,
    [s.grayColor]: grayColor,
    [s.blackColor]: blackColor,
    [s.blackToBrandColor]: blackToBrandColor,
    [s[color]]: color,
    [s.underlineBrandColor]: underlineBrandColor,
    [s.underlineDashedBrandColor]: underlineDashedBrandColor,
    [s.styleless]: styleless,
    [s.bold]: bold,
  })

  return (
    <Href className={composedClassName} {...rest} />
  )
}

Link.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  messageName: PropTypes.string,
  to: PropTypes.string,
  toOLD: PropTypes.string,
  redirect: PropTypes.string,
  mailto: PropTypes.string,
  brandColor: PropTypes.bool,
  blackColor: PropTypes.bool,
  grayColor: PropTypes.bool,
  blackToBrandColor: PropTypes.bool,
  customColor: PropTypes.bool,
  styleless: PropTypes.bool,
  withHtmlTitle: PropTypes.bool,
  underlineBrandColor: PropTypes.bool,
  underlineDashedBrandColor: PropTypes.bool,
}

Link.defaultProps = {
  brandColor: false,
  blackColor: false,
  grayColor: false,
  customColor: false,
  withHtmlTitle: false,
  underlineBrandColor: false,
  underlineDashedBrandColor: false,
}


export default Link
